
import cancun from "../../../assets/images/HomePage/cancun.webp";
import islamujeres from "../../../assets/images/HomePage/islamujeres.webp";
import mahahual from "../../../assets/images/HomePage/mahahual.webp";
import cozumel from "../../../assets/images/HomePage/marinaplaya.webp";
import mayakan from "../../../assets/images/HomePage/mayakan.webp";
import playa from "../../../assets/images/HomePage/playa.webp";
import playamoroma from "../../../assets/images/HomePage/playamoroma.webp";
import puertomorelos from "../../../assets/images/HomePage/puertomorelos.webp";
import chetumal from "../../../assets/images/HomePage/chetumal.webp";
import tulum from "../../../assets/images/HomePage/tulum.webp";
import bacalar from "../../../assets/images/HomePage/bacalar.webp";
import avatar from "../../../assets/images/HomePage/Icons/ICONOS_WEB_VISITAX-08.webp"
import { DefaultText } from "../../../context/ConfigurationsContext/defaultdata/defauldata";

export const destinations = (txt: DefaultText) => {
    return [
        {
            name: "Cancún",
            image: `${cancun}`,
            description: `${txt[151]}`,
        },
        {
            name: "Playa del Carmen",
            image: `${playamoroma}`,
            description: `${txt[152]}`,
        },
        {
            name: "Tulum",
            image: `${tulum}`,
            description: `${txt[153]}`,
        },
        {
            name: "Chetumal",
            image: `${chetumal}`,
            description: `${txt[154]}`,
        },
        {
            name: "Bacalar",
            image: `${bacalar}`,
            description: `${txt[155]}`,
        },
        {
            name: "Cozumel",
            image: `${cozumel}`,
            description: `${txt[156]}`,
        },
        {
            name: "Isla Mujeres",
            image: `${islamujeres}`,
            description: `${txt[157]}`,
        },
        {
            name: "Holbox",
            image: `${playa}`,
            description: `${txt[158]}`,
        },
        {
            name: "Mahahual",
            image: `${mahahual}`,
            description: `${txt[159]}`,
        },
        {
            name: "Maya Ka'an",
            image: `${mayakan}`,
            description: `${txt[160]}`,
        },
        {
            name: "Puerto Morelos",
            image: `${puertomorelos}`,
            description: `${txt[161]}`,
        },
    ];
}

export const testimonials = (txt: DefaultText) => {
    return [
        {
            id: 1,
            text: `${txt[142]}`,
            name: "Brianna Carter",
            rating: 5,
            url: `${avatar}`,
        },
        {
            id: 2,
            text: `${txt[143]}`,
            name: "Ashley Reynolds",
            rating: 4,
            url: `${avatar}`,
        },
        {
            id: 3,
            text: `${txt[144]}`,
            name: "Jonathan Thompson ",
            rating: 5,
            url: `${avatar}`,
        },
    ];

}
